export const signUp = {
  form: {
    acceptedTerms:
      "I accept Conceive’s <TermsLink>Terms of Service</TermsLink> and <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>. I understand that Conceive connects me with providers and fertility experts to support and educate me throughout my journey. Conceive does not offer medical advice and is not licensed to provide such services.",
    submit: "Next",
    title: "What’s your email?",
  },
  programHighlights: {
    coach: {
      description:
        "You’ll be matched with a coach who’s been through it before and will be on-hand any time to answer all your questions.",
      title: "Fertility coach on-call, 24/7",
    },
    crew: {
      description:
        "We find you a community made up of people in the same boat, who you can meet and message with. Meet your new fertility fam.",
      title: "10 peers who really get it",
    },
    recommendations: {
      description:
        "You’ll have personalized data-driven tips and tasks from our experts, delivered every week. ",
      title: "Weekly evidence-based tips",
    },
  },
  signInLink:
    "<Bold>Already have an account?</Bold> <SignInLink>Sign in</SignInLink>",
  subheading:
    "<ReddishHighlight>61%</ReddishHighlight> of our members have become pregnant within six months of joining and had a <YellowHighlight>77%</YellowHighlight> increase in feelings of support. Here’s how:",
  title: "Let's get started",
};
